import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { GET_GETTING_STARTED_STEPS, GET_TRIAL_DAYS_REMAINING } from '@app/store/constants';
import { DispatchFunction, IWelcomeStep, ITrialDaysRemaining } from '@app/models';
import { gettingStartedService } from '@app/services';

export function handleGettingStartedData(): DispatchFunction {
    return ((dispatch: Dispatch) => {
        gettingStartedService.getWelcomeSteps()
            .then((response: AxiosResponse) => {
                dispatch(getGettingStartedSteps(response.data.value));
            });

        gettingStartedService.getTrialDaysRemaining()
            .then((response: AxiosResponse) => {
                dispatch(getGettingTrialDaysRemaining(response.data));
            });
    });
}

export function getGettingStartedSteps(steps: IWelcomeStep[]) {
    return {
        payload: steps,
        type: GET_GETTING_STARTED_STEPS
    };
}

export function getGettingTrialDaysRemaining(trialDaysRemaining: ITrialDaysRemaining) {
    return {
        payload: trialDaysRemaining,
        type: GET_TRIAL_DAYS_REMAINING
    };
}
